import { Select, SelectProps, styled } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const CustomSelect = styled(Select)<SelectProps>(({ theme }) => ({
  '& .MuiSelect-root': {
    borderRadius: '8px',
  },
  '& .MuiSelect-select': {
    paddingLeft: '14px',
    paddingRight: '32px',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiSelect-icon': {
    top: 'calc(50% - 12px)',
    right: '8px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #B3B3B3',
    borderRadius: '8px',
  },
  textAlign: 'left',
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '2px solid #B3B3B3',
  },
}));

export const useStyles = makeStyles(() => ({
  Option: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    wordBreak: 'break-all',
  },
}));
